import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const TRIHEALTH_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
  [UserRole.EXECUTIVE]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER_LIMITED_PHI]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
    Permissions.GENETIC_COUNSELING,
  ],
};
